var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var ERuleProps;
(function (ERuleProps) {
    ERuleProps["REQUIRED"] = "REQUIRED";
    ERuleProps["CHINESE_ENGLISH_NUMERIC"] = "CHINESE_ENGLISH_NUMERIC";
    ERuleProps["CHINESE_ENGLISH_NUMERIC_LIMITED_SPECIAL"] = "CHINESE_ENGLISH_NUMERIC_LIMITED_SPECIAL";
    ERuleProps["CHINESE_ENGLISH_NUMERIC_SPECIAL"] = "CHINESE_ENGLISH_NUMERIC_SPECIAL";
    ERuleProps["ENGLISH_NUMERIC"] = "ENGLISH_NUMERIC";
    ERuleProps["JAPANESE_LIFF_NAME_RULE"] = "JAPANESE_LIFF_NAME_RULE";
    ERuleProps["PASSWORD"] = "PASSWORD";
    ERuleProps["EMAIL"] = "EMAIL";
    ERuleProps["GENERAL_PHONE_NUMBER"] = "GENERAL_PHONE_NUMBER";
    ERuleProps["TAIWANESE_CELLPHONE_NUMBER"] = "TAIWANESE_CELLPHONE_NUMBER";
    ERuleProps["DIGIT_COUNT"] = "DIGIT_COUNT";
    ERuleProps["POWER"] = "POWER";
    ERuleProps["ELECTRIC_CURRENT"] = "ELECTRIC_CURRENT";
    ERuleProps["ELECTRIC_VOLTAGE"] = "ELECTRIC_VOLTAGE";
    ERuleProps["ELECTRICITY_RATE"] = "ELECTRICITY_RATE";
    ERuleProps["LATITUDE"] = "LATITUDE";
    ERuleProps["LONGITUDE"] = "LONGITUDE";
    ERuleProps["PILE_NUM"] = "PILE_NUM";
    ERuleProps["INVOICE_CARRIER"] = "INVOICE_CARRIER";
    ERuleProps["CITIZEN_DIGITAL_CERT"] = "CITIZEN_DIGITAL_CERT";
    ERuleProps["COMPANY_TAX_ID"] = "COMPANY_TAX_ID";
    ERuleProps["CARBON_EMISSION_FACTOR"] = "CARBON_EMISSION_FACTOR";
    ERuleProps["GOOGLE_MAPS_URL"] = "GOOGLE_MAPS_URL";
    ERuleProps["JAPANESE_ENGLISH_NUMERIC"] = "JAPANESE_ENGLISH_NUMERIC";
    ERuleProps["JAPANESE_ENGLISH_NUMERIC_LIMITED_SPECIAL"] = "JAPANESE_ENGLISH_NUMERIC_LIMITED_SPECIAL";
    ERuleProps["JAPANESE_ENGLISH_NUMERIC_SPECIAL"] = "JAPANESE_ENGLISH_NUMERIC_SPECIAL";
    ERuleProps["JAPANESE_CELLPHONE_NUMBER"] = "JAPANESE_CELLPHONE_NUMBER";
    ERuleProps["CREDIT_CARD_HOLDER_NAME"] = "CREDIT_CARD_HOLDER_NAME";
    ERuleProps["URL"] = "URL";
})(ERuleProps || (ERuleProps = {}));
/**
 * 常用正則規則
 * @example 使用方法：regexStandardRules.CHINESE_ENGLISH_NUMERIC(true)，則代表使用 CHINESE_ENGLISH_NUMERIC 規則，且為必填欄位
 */
var regexStandardRules = {
    /**
     * 供單純必填欄位使用，例如下拉選單、日期選擇器等
     */
    REQUIRED: function (t) { return ({
        required: true,
        message: t('Model.RequiredField'),
    }); },
    /**
     * 僅英文、數字、中文、空格，及 1 到 80 個字元可通過驗證
     * @type {RegExp}
     * @example "A", "中文English123", "a".repeat(80)
     * @param 若為選填，則可為空值
     * @param 第二個參數為字元上限
     */
    CHINESE_ENGLISH_NUMERIC: function (t, required, max) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 80; }
        return ({
            required: required,
            pattern: new RegExp("^([\u4E00-\u9FA5a-zA-Z0-9\\s]{".concat(!required ? 0 : 1, ",").concat(max, "}").concat(!required ? '|' : '', ")$|^$")),
            message: t('Model.ChineseEnglishNumeric', {
                required: required ? t('Model.Required') : t('Model.Optional'),
                max: max,
            }),
        });
    },
    /**
     * 僅英文、數字、中文、空格、特殊符號 -_()－＿（），及 1 到 80 個字元可通過驗證
     * @type {RegExp}
     * @example "A", "中文English123", "a".repeat(80)
     * @param 若為選填，則可為空值
     * @param 第二個參數為字元上限
     */
    CHINESE_ENGLISH_NUMERIC_LIMITED_SPECIAL: function (t, required, max) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 80; }
        return ({
            required: required,
            pattern: new RegExp("^([\\u4e00-\\u9fa5a-zA-Z0-9\\s\\-_()\uFF0D\uFF3F\uFF08\uFF09]{".concat(!required ? 0 : 1, ",").concat(max, "}").concat(!required ? '|' : '', ")$|^$")),
            message: t('Model.ChineseEnglishNumericLimitedSpecial', {
                required: required ? t('Model.Required') : t('Model.Optional'),
                max: max,
            }),
        });
    },
    /**
     * 僅英文、數字、中文、允許所有 ASCII 符號 ，及 1 到 80 個字元可通過驗證
     * @type {RegExp}
     * @example "A", "中文English12*(!@&#)_!$@(_3", "a".repeat(80)
     * @param 若為選填，則可為空值
     * @param 第二個參數為字元上限
     */
    CHINESE_ENGLISH_NUMERIC_SPECIAL: function (t, required, max) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 80; }
        return ({
            required: required,
            pattern: new RegExp("^[A-Za-z0-9\u4E00-\u9FA5!-~\uFF01-\uFFEF\u2000-\u303F\\s]{".concat(required ? '1' : '0', ",").concat(max, "}$")),
            message: t('Model.ChineseEnglishNumericSpecial', {
                required: required ? t('Model.Required') : t('Model.Optional'),
                max: max,
            }),
        });
    },
    /**
     * 僅英文、數字、.、_，及 1 到 20 個字元可通過驗證
     * @type {RegExp}
     * @example "A", "123", "a1293819"
     * @param 若為選填，則可為空值
     * @param 第二個參數為字元上限
     */
    ENGLISH_NUMERIC: function (t, required, max) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 20; }
        return ({
            required: required,
            pattern: new RegExp("^([A-Za-z0-9._]{1,".concat(max, "}").concat(!required ? '|' : '', ")$")),
            message: t('Model.EnglishNumeric', {
                required: required ? t('Model.Required') : t('Model.Optional'),
                max: max,
            }),
        });
    },
    /**
     * 日本版 LIFF 會員中心會員名稱規則，必填且最大字數 80 字元可通過驗證
     * @type {RegExp}
     */
    JAPANESE_LIFF_NAME_RULE: function (t) {
        return {
            required: true,
            pattern: new RegExp("^.{1,80}$"),
            message: t('UserInfo.JapaneseLIFFNameRule'),
        };
    },
    /**
     * 至少 1 個英文、1 個數字，並支援以下特殊符號 '-!#$%&()*,./:;?@[]^_`{|}~+<=>，及 8 到 30 個字元可通過驗證
     * @type {RegExp}
     * @example "Password1!", "a1-!#$%&()", "A".repeat(8) + "1!"
     */
    PASSWORD: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\-!#$%&()*,./:;?@[\]^_`'{|}~+<=>]{8,30}$/,
            message: t('Model.Password'),
        });
    },
    /**
     * 電子郵件格式：並支援以下特殊符號 `-.@_+`，可通過驗證
     * @type {RegExp}
     * @example "example@example.com", "user.name@example.co.uk"
     * @param 若為選填，則可為空值
     */
    EMAIL: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^([\\w\\.\\+\\-\\_]+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,6})".concat(!required ? '|' : '', ")$")),
            message: t('Model.CorrectEmail', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 電話、手機號碼格式：數字，支援以下特殊符號 `()+-#`，及 8 ~ 20 個字元可通過驗證
     * @tutorial 記得將該欄位轉為字串再進行驗證
     * @type {RegExp}
     * @example "(02)12345678", "0912345678", "+886-2-1234-5678"
     * @param 若為選填，則可為空值
     */
    GENERAL_PHONE_NUMBER: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^([\\d()+\\-#]{8,20}".concat(!required ? '|' : '', ")$")),
            message: t('Model.GeneralPhoneNumber', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 台灣手機號碼格式：數字，`09` 開頭，總共 10 個字元，方可通過驗證
     * @tutorial 十碼手機號碼會被 JS 解釋為十進位，因此開頭 0 會被去除，所以我們得將該欄位轉為字串再進行驗證
     * @type {RegExp}
     * @example "0912345678", "0987654321"
     * @param 若為選填，則可為空值
     */
    TAIWANESE_CELLPHONE_NUMBER: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^(09\\d{8}".concat(!required ? '|' : '', ")$")),
            message: t('Model.TaiwaneseCellphoneNumber', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 數字個數：數字，數值範圍 1 ~ 10,000，方可通過驗證
     * @type {RegExp}
     * @example "1", "10000", "5000"
     * @param 若為選填，則可為空值
     */
    DIGIT_COUNT: function (t, required, max, min) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 10000; }
        if (min === void 0) { min = 1; }
        if (min < 0 || max < 0 || min > max) {
            throw new Error('Invalid range: min and max should be non-negative, and min should be less than or equal to max.');
        }
        var minLength = min.toString().length;
        var maxLength = max.toString().length;
        return {
            required: required,
            pattern: new RegExp("^(".concat(min, "|[1-9]\\d{").concat(Math.max(minLength - 1, 0), ",").concat(maxLength - 2, "}|").concat(max, ")").concat(!required && max === 0 ? '?' : '', "$")),
            message: t('Model.DigitCount', { max: max.toLocaleString() }),
        };
    },
    /**
     * 額定功率 (kW)：數字，數值範圍 1 ~ 600，方可通過驗證
     * @type {RegExp}
     * @example "1", "100", "600"
     * @param 若為選填，則可為空值
     */
    POWER: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^(?:(?:[1-9]|[1-9][0-9]|[1-5][0-9]{2}|59[0-9]|600)".concat(!required ? '|' : '', ")?$")),
            message: t('Model.Power', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 額定電流 (A)：數字，數值範圍 1 ~ 500，方可通過驗證
     * @type {RegExp}
     * @example "1", "250", "500", "500"
     * @param 若為選填，則可為空值
     */
    ELECTRIC_CURRENT: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^(?:(?:[1-9]|[1-9][0-9]|[1-4][0-9]{2}|49[0-9]|500)".concat(!required ? '|' : '', ")?$")),
            message: t('Model.ElectricCurrent', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 額定電壓 (V)：數字，數值範圍 110 ~ 1200，方可通過驗證
     * @tutorial 推薦將此欄位轉為字串再進行驗證
     * @type {RegExp}
     * @example "110", "1200", "600"
     * @param 若為選填，則可為空值
     */
    ELECTRIC_VOLTAGE: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^(?:(?:11[0-9]|1[2-9][0-9]|[2-9][0-9]{2}|1[01][0-9]{2}|1200)".concat(!required ? '|' : '', ")?$")),
            message: t('Model.ElectricVoltage', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 電費費率：數字，允許至小數點後 1 位，數值範圍 0 ~ 20，方可通過驗證
     * @type {RegExp}
     * @example "1", "50", "50.0", "25.5"
     * @param 若為選填，則可為空值
     */
    ELECTRICITY_RATE: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: /^(?:0|(?:1[0-9]|[1-9])(?:\.\d)?|20(?:\.0)?)$/,
            message: t('Model.ElectricityRate', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 驗證緯度：數字，允許範圍從 -90 至 90，允許小數至多6位。
     * 包括 "-77.0364", "90", "-90.0", 以及 "0"。
     * @param {boolean} required - 如果為 true，則此欄位不能為空。
     * @returns {Object} 返回驗證模式和緯度的訊息。
     */
    LATITUDE: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^[-+]?([1-8]?\\d(\\.\\d{0,6})?|90(\\.0+)?)".concat(required ? '' : '|^$', "$")),
            message: t('Model.Latitude', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 驗證經度：數字，允許範圍從 -180 至 180，允許小數至多6位。
     * 包括 "-180", "180", "-45.0", 以及 "0"。
     * @param {boolean} required - 如果為 true，則此欄位不能為空。
     * @returns {Object} 返回驗證模式和經度的訊息。
     */
    LONGITUDE: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^[-+]?((1[0-7]\\d|[1-9]?\\d)(\\.\\d+)?|180(\\.0+)?)".concat(required ? '' : '|^$', "$")),
            message: t('Model.Longitude', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 僅英文、數字，及 6 到 50 個字元可通過驗證
     * @example "ABCDEF", "123456", "a1293819"
     * @param 若為選填，則可為空值
     */
    PILE_NUM: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^([A-Za-z0-9_-]{6,50}".concat(!required ? '|' : '', ")$")),
            message: t('Model.PileNumber', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 手機載具：第 1 碼為 `/`，其餘 7 碼為 0-9, A-Z, `.`, `-`, `+`，總共 8 碼，方可通過驗證
     * @type {RegExp}
     * @example "/1234567", "/A123456"
     * @param 若為選填，則可為空值
     */
    INVOICE_CARRIER: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^(\\/[0-9A-Za-z.+-]{7})".concat(!required ? '?' : '', "$")),
            message: t('Model.InvoiceCarrier', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 自然人憑證條碼載具：前 2 碼為 A-Z，其餘 14 碼為 0-9，總共 16 碼，方可通過驗證
     * @type {RegExp}
     * @example "AA12345678901234", "BB12345678901234
     * @param 若為選填，則可為空值
     */
    CITIZEN_DIGITAL_CERT: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^([A-Za-z]{2}[0-9]{14})".concat(!required ? '?' : '', "$")),
            message: t('Model.CitizenDigitalCert', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 公司統一編號：皆為數字，共 8 碼，方可通過驗證
     * @type {RegExp}
     * @example "12345678"
     * @param 若為選填，則可為空值
     */
    COMPANY_TAX_ID: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^(\\d{8}$)".concat(!required ? '?' : '')),
            message: t('Model.CompanyTaxId', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 碳排係數：數字，最多可至小數點三位，範圍需為 0 ~ 9 之間
     * @type {RegExp}
     * @example "0.000", "0.00", "0.0", "8.123"
     * @param 若為選填，則可為空值
     */
    CARBON_EMISSION_FACTOR: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^(?:[0-8]\\.\\d{1}|[0-8]\\.\\d{2}|[0-8]\\.\\d{3}|[0-9]|9\\.0|9\\.00|9\\.000)".concat(!required ? '?' : '', "$")),
            message: t('Model.CarbonEmissionFactor', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * Google Maps URL 驗證：必須以 https://maps.app.goo.gl/ 開頭，且總長度不超過 300 個字元
     * @type {RegExp}
     * @example "https://maps.app.goo.gl/abc123"
     * @param 若為選填，則可為空值
     */
    GOOGLE_MAPS_URL: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^(https:\\/\\/maps\\.app\\.goo\\.gl\\/.{1,276})".concat(!required ? '?' : '', "$")),
            message: t('Model.GoogleMapsURL'),
        });
    },
    /** *************************************  以下日本版  ************************************** */
    /**
     * 僅日文、英文、數字、空格，及 1 到 80 個字元可通過驗證
     * @type {RegExp}
     * @example "あいうえお", "English123", "カタカナ123", "a".repeat(80)
     * @param 若為選填，則可為空值
     * @param 第二個參數為字元上限
     */
    JAPANESE_ENGLISH_NUMERIC: function (t, required, max) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 80; }
        return ({
            required: required,
            pattern: new RegExp("^([\\u4e00-\\u9fa5\\u3040-\\u30FF\\u31F0-\\u31FFa-zA-Z0-9\\s]{".concat(!required ? 0 : 1, ",").concat(max, "}").concat(!required ? '|' : '', ")$|^$")),
            message: t('Model.JapaneseEnglishNumeric', {
                required: required ? t('Model.Required') : t('Model.Optional'),
                max: max,
            }),
        });
    },
    /**
     * 僅日文、英文、數字、空格、特殊符號 -_()－＿（），及 1 到 80 個字元可通過驗證
     * @type {RegExp}
     * @example "あいうえお123", "English_123", "カタカナ-(123)", "a".repeat(80)
     * @param 若為選填，則可為空值
     * @param 第二個參數為字元上限
     */
    JAPANESE_ENGLISH_NUMERIC_LIMITED_SPECIAL: function (t, required, max) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 80; }
        return ({
            required: required,
            pattern: new RegExp("^([\\u4e00-\\u9fa5\\u3040-\\u30FF\\u31F0-\\u31FFa-zA-Z0-9\\s\\-_()\uFF0D\uFF3F\uFF08\uFF09]{".concat(!required ? 0 : 1, ",").concat(max, "}").concat(!required ? '|' : '', ")$|^$")),
            message: t('Model.JapaneseEnglishNumericLimitedSpecial', {
                required: required ? t('Model.Required') : t('Model.Optional'),
                max: max,
            }),
        });
    },
    /**
     * 僅日文、英文、數字、所有 ASCII 符號，及 1 到 80 個字元可通過驗證
     * @type {RegExp}
     * @example "あいうえお", "English123*(!@&#)_!$", "カタカナ", "a".repeat(80)
     * @param 若為選填，則可為空值
     * @param 第二個參數為字元上限
     */
    JAPANESE_ENGLISH_NUMERIC_SPECIAL: function (t, required, max) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 80; }
        return ({
            required: required,
            pattern: new RegExp("^[\\u4e00-\\u9fa5\\u3040-\\u30FF\\u31F0-\\u31FFa-zA-Z0-9\\x21-\\x7e\\uff01-\\uffef\\u2000-\\u303f\\s]{".concat(required ? '1' : '0', ",").concat(max, "}$")),
            message: t('Model.JapaneseEnglishNumericSpecial', {
                required: required ? t('Model.Required') : t('Model.Optional'),
                max: max,
            }),
        });
    },
    /**
     * 日本手機號碼格式：僅限數字，必須為 11 碼
     * @type {RegExp}
     * @example "07012345678", "08098765432", "09011112222"
     * @param 若為選填，則可為空值
     */
    JAPANESE_CELLPHONE_NUMBER: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: new RegExp("^\\d{11}".concat(!required ? '|' : '', "$")),
            message: t('Model.TaiwaneseCellphoneNumber', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
    /**
     * 僅允許英文、空格及特定符號，且 1 到指定字元數可通過驗證
     * @type {Function}
     * @param {boolean} required 是否為必填
     * @param {number} max 最大字元數
     */
    CREDIT_CARD_HOLDER_NAME: function (t, required, max) {
        if (required === void 0) { required = true; }
        if (max === void 0) { max = 50; }
        return ({
            required: required,
            pattern: new RegExp("^([a-zA-Z\\s\",\\.\\-/]{".concat(!required ? 0 : 1, ",").concat(max, "}").concat(!required ? '|' : '', ")$|^$")),
            message: t('Model.CreditCardHolderName', {
                required: required ? t('Model.Required') : t('Model.Optional'),
                max: max,
            }),
        });
    },
    /**
     * 網址驗證規則，必須以 https: 開頭，且 https:// 後僅允許英數字 (a-zA-Z0-9)，主網域部分允許使用英數字與 -（但  - 不能出現在開頭或結尾），並且至少包含一個 .，最後的頂級域名（TLD）只能由英文字母組成（如 .com、.org）。此外，允許使用端口號（如 :8080）、路徑（/path）、查詢參數（?key=value）及 Fragment 錨點（#section），不允許空格。
     * @type {Function}
     * @param {boolean} required 是否為必填
     */
    URL: function (t, required) {
        if (required === void 0) { required = true; }
        return ({
            required: required,
            pattern: /^(https:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/\S*)?(\?\S*)?(#\S*)?$/,
            message: t('Model.URL', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            }),
        });
    },
};
/**
 * TDX 樓層，僅允許第一個字元可為 B，其餘皆須為數字方可通過驗證
 * @type {Function}
 * @param {boolean} required 是否為必填
 * @example ✅：B1, B99999, 1, 99999
 * @example ❌：B01, C1, -1
 */
function tdxFloorRule(t, required) {
    if (required === void 0) { required = true; }
    return {
        required: required,
        validator: function (_, floor) {
            return __awaiter(this, void 0, void 0, function () {
                var hasB, tdxFloorRegex, msg;
                return __generator(this, function (_a) {
                    if (!required && !floor) {
                        return [2 /*return*/, Promise.resolve()];
                    }
                    hasB = String(floor).startsWith('B');
                    tdxFloorRegex = hasB ? /^B([1-9][0-9]*)$/ : /^[1-9][0-9]*$/;
                    msg = t('Model.Floor', {
                        required: required ? t('Model.Required') : t('Model.Optional'),
                    });
                    if (!floor || !tdxFloorRegex.test(floor)) {
                        return [2 /*return*/, Promise.reject(msg)];
                    }
                    return [2 /*return*/, Promise.resolve()];
                });
            });
        },
    };
}
/**
 * 以 RFC 5321 和 RFC 5322 對電子郵件地址格式的完整規範為基底，並擴充規則以符合大多數伺服器要求。
 * 本實作規範不包含少見的細微規範，如 Quoted Strings (")、Comments (())，以及 Domain Literals ([...])。
 * 大多數郵件伺服器要求有一個有效的頂級域（TLD）。因此，本實作規範要求電子郵件地址的頂級域至少有兩個字符。
 * *為什麼不使用 Regex 來實現這邊的 email 規範呢？* 因為 email 驗證非常複雜，不容易使用 Regex 來實現。可參閱此文件延伸閱讀：https://stackoverflow.com/questions/20771794/mailrfc822address-regex
 */
function emailRule(t, required) {
    if (required === void 0) { required = false; }
    return {
        required: required,
        validator: function (_, email, callback) {
            if (!required && !email) {
                callback();
                return;
            }
            var msg = t('Model.CorrectEmail', {
                required: required ? t('Model.Required') : t('Model.Optional'),
            });
            if (!email) {
                callback(msg);
                return;
            }
            // 定義RFC 5322所規定的電子郵件正則表達式
            var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            // 檢查總長度是否超過254個字符
            if (email.length > 254) {
                callback(msg);
                return;
            }
            // 使用正則表達式檢查電子郵件格式
            if (!emailRegex.test(email)) {
                callback(msg);
                return;
            }
            // 分割local-part和domain部分
            var _a = email.split('@'), localPart = _a[0], domain = _a[1];
            // 檢查local-part是否超過64個字符
            if (localPart.length > 64) {
                callback(msg);
                return;
            }
            // 檢查local-part中點的規範
            if (localPart.startsWith('.') ||
                localPart.endsWith('.') ||
                localPart.includes('..')) {
                callback(msg);
                return;
            }
            // 檢查domain部分是否包含至少一個點和有效的頂級域
            var domainParts = domain.split('.');
            if (domainParts.length < 2) {
                callback(msg);
                return;
            }
            // 檢查domain部分的每個標籤
            if (domainParts.some(function (part) {
                return part.length > 63 || part.startsWith('-') || part.endsWith('-');
            })) {
                callback(msg);
                return;
            }
            // 檢查頂級域是否至少有兩個字符
            var topLevelDomain = domainParts[domainParts.length - 1];
            if (topLevelDomain.length < 2) {
                callback(msg);
                return;
            }
            callback();
        },
    };
}
export { regexStandardRules, emailRule, tdxFloorRule };
